import React from "react";
import { useLocation, useNavigate } from "react-router";

interface ContinueRedirectProps {
  to: string;
}

export function ContinueRedirect(props: ContinueRedirectProps) {
  const { to } = props;

  const currentRoute = useLocation();

  const redirectPath = `${to}?continue=${encodeURIComponent(
    currentRoute.pathname + currentRoute.search
  )}`;

  const navigate = useNavigate();

  React.useEffect(() => {
    navigate(redirectPath);
  }, [navigate, redirectPath]);

  return null;
}
